// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iconWrapper___f7dd4ddce33e0717","iconWrapperMobile":"iconWrapperMobile___e397c940eb9d7172"};